import React from 'react'
import { connect } from 'react-redux'
import { lineups } from 'redux/modules'
import PropTypes from 'prop-types'
import Loader from './Loader'

const LineupLoader = ({ children, lineupUuid, fetchLineup, ...restProps }) => (
  <Loader fetchMethod={() => fetchLineup(lineupUuid)} {...restProps}>
    {children}
  </Loader>
)

LineupLoader.propTypes = {
  children: PropTypes.node.isRequired,
  lineupUuid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fetchLineup: PropTypes.func.isRequired,
}

export default connect(
  null,
  { fetchLineup: lineups.fetchLineup }
)(LineupLoader)
